import { Injectable } from '@angular/core';
import { Charge } from '../shared/models/Charge';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError, tap } from 'rxjs/operators';
import { CHARGE_URL } from '../shared/constats/urls';

@Injectable({
  providedIn: 'root'
})

export class ChargeService {

  constructor(private http: HttpClient, private toastrService: ToastrService,) { }

  saveCharge(charge: Charge): Observable<any> {
    return this.http.post(CHARGE_URL + '/', charge).pipe(
      catchError((error) => {
        this.toastrService.error('Error al guardar la carga', 'Error');
        throw error;
      }),
      tap(() => {
        // this.toastrService.success('Carga guardado con éxito', 'Éxito');
      })
    );
  }

  editCharge(id: number, charge: Charge): Observable<any> {
    return this.http.put(CHARGE_URL + '/' + id, charge);
  }


  getAll(): Observable<Charge[]> {
    return this.http.get<Charge[]>(CHARGE_URL);
  }

  getCharge(id: number): Observable<Charge> {
    return this.http.get<Charge>(CHARGE_URL + '/' + id);
  }

  deleteCharge(id: number): Observable<any> {
    return this.http.delete(CHARGE_URL + '/' + id);
  }

  getChargeByTank(tankId: number): Observable<Charge[]> {
    return this.http.get<Charge[]>(CHARGE_URL + '/getChargeByTank/' + tankId);
  }

}
